import { formatVerbiage } from "@repo/helpers";
import { RepFieldAudit, SortTypeEnum } from "@repo/models";
import { Column, GridBaseProps, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";
import { useMemo } from "react";

import { useRepFieldAuditQueries } from "../../../api/repFieldAuditApi";
import { useSettingsApi } from "../../../api/settingsApi";
import { useVerbiageQuery } from "../../../api/verbiageApi";

function passFormatter(audit: RepFieldAudit) {
	if (!audit.showScore) return "";

	return audit.pass ? "Pass" : "Fail";
}

export default function FieldAuditGridBasic(props: GridBaseProps<RepFieldAudit>) {
	const { useRepFieldAuditQuery } = useRepFieldAuditQueries();
	const { data, loaded, clearQuery } = useRepFieldAuditQuery();
	const { useSettingsQuery } = useSettingsApi();
	const { data: settings } = useSettingsQuery();
	const verbiage = useVerbiageQuery();

	const columns = useMemo(() => {
		return (
			[
				new Column("Form Type", "formTypeName")
					.withFormat((formType) => formatVerbiage(formType, verbiage))
					.withMinWidth(120),
				settings?.showAuditType &&
					new Column("Audit Type", "auditTypeName")
						.withFormat((auditType) => formatVerbiage(auditType, verbiage))
						.withMinWidth(120),
				new Column("QA Analyst", "qaAnalyst").withMinWidth(120),
				new OriginalTimezoneDateColumn("Audit Date", "auditDate")
					.withMinWidth(140)
					.dateOnly()
					.withSortBy(SortTypeEnum.descending),
				new Column("Passed RoE").withFormat(passFormatter).withMinWidth(100),
				new Column("Comments", "comments").withMinWidth(300),
			] as Column<RepFieldAudit>[]
		).filter(Boolean);
	}, [verbiage, settings?.showAuditType]);

	return (
		<GridPreLoaded<RepFieldAudit>
			{...props}
			title={verbiage.fieldAudit}
			columns={columns}
			values={data?.data ?? []}
			loading={!loaded}
			getData={clearQuery}
		/>
	);
}
